/**
 * 绘制工具控件
 */
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-draw/dist/leaflet.draw.css';
import 'leaflet-draw';

export default class DrawControl {
    constructor(options = {}) {
        this.options = options;
        this.drawControl = null;
        // 默认是一个空的L.FeatureGroup
        this.drawnItems = options.drawnItems || new L.FeatureGroup();
        this.init();
    }
    // 初始化控制器
    init() {
        const { draw, edit } = this.options;
        // 默认绘制选项
        const drawOptions = {
            polygon: {
                allowIntersection: false, // 不允许多边形自交
                drawError: {
                    color: '#b00b00', // 错误时的颜色
                    message: '<strong>Error:</strong> 不允许自交的多边形!' // 错误提示信息
                },
                shapeOptions: {
                    color: '#bada55' // 多边形的颜色
                }
            },
            rectangle: {
                shapeOptions: {
                    color: '#ff0000' // 矩形的颜色
                }
            },
            polyline: true, // 绘制线条
            circle: true,   // 绘制圆形
            circlemarker:false, //禁用绘制圆形标记
            marker: true    // 绘制标记
        };

        const editOptions = {
            featureGroup: this.drawnItems, // 允许编辑已绘制的图形
            remove: true // 允许删除已绘制的图形
        };

        // 如果有自定义配置，使用自定义选项
        this.drawControl = new L.Control.Draw({
            draw: Object.assign(drawOptions, draw), // 合并自定义draw选项
            edit: Object.assign(editOptions, edit)  // 合并自定义edit选项
        });
    }

    // 添加到地图
    addTo(map) {
        if (this.drawControl && map) {
            map.addControl(this.drawControl);
        }
    }

    // 返回绘制控件
    getDrawControl() {
        return this.drawControl;
    }

    // 清除所有已绘制的图形
    clearDrawnItems() {
        this.drawnItems.clearLayers();
    }
}